// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__woYAb","crane":"NotFound_crane__OHoaB"};